import { useState, useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

interface TeamsContextState {
  initialized: boolean;
  context: microsoftTeams.app.Context | null;
  isInTeams: boolean;
}

let globalInitialized = false;

export function useTeamsContext(): TeamsContextState {
  const [state, setState] = useState<TeamsContextState>({
    initialized: false,
    context: null,
    isInTeams: false,
  });

  useEffect(() => {
    const init = async () => {
      try {
        await microsoftTeams.app.initialize();
        const context = await microsoftTeams.app.getContext();
        globalInitialized = true;
        setState({ initialized: true, context, isInTeams: true });
      } catch {
        // Not running in Teams (dev mode)
        globalInitialized = true;
        setState({ initialized: true, context: null, isInTeams: false });
      }
    };

    if (!globalInitialized) {
      init();
    } else {
      setState((s) => ({ ...s, initialized: true }));
    }
  }, []);

  return state;
}

export function getTeamsSsoToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    microsoftTeams.authentication.getAuthToken({
      successCallback: resolve,
      failureCallback: reject,
    });
  });
}
